"use client"

import * as React from "react"
import * as AccordionPrimitive from "@radix-ui/react-accordion"
import { ChevronDownIcon } from "@radix-ui/react-icons"

import { cn } from "@/lib/utils"

const Accordion = AccordionPrimitive.Root

const AccordionItem = (
  {
    className,
    ...props
  }: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Item>
) => (<AccordionPrimitive.Item
  data-slot="item"
  className={cn("border-b", className)}
  {...props}
/>)
AccordionItem.displayName = "AccordionItem"

const AccordionTrigger = (
  {
    className,
    children,
    ...props
  }: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Trigger>
) => (<AccordionPrimitive.Header className="flex">
  <AccordionPrimitive.Trigger
    data-slot="trigger"
    className={cn(
      "flex flex-1 items-center justify-between py-4 text-sm font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      className
    )}
    {...props}
  >
    {children}
    <ChevronDownIcon className="h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" />
  </AccordionPrimitive.Trigger>
</AccordionPrimitive.Header>)
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName

const AccordionContent = (
  {
    className,
    children,
    ...props
  }: React.ComponentPropsWithoutRef<typeof AccordionPrimitive.Content>
) => (<AccordionPrimitive.Content
  data-slot="content"
  className="overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down"
  {...props}
>
  <div className={cn("pb-4 pt-0", className)}>{children}</div>
</AccordionPrimitive.Content>)
AccordionContent.displayName = AccordionPrimitive.Content.displayName

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
